import { ApiService } from "./ApiService";
export class SocialLogin {
    static open(type, onResponse) {
        window.receiveDataFromPopup = function (auth) {
            onResponse(auth);
        };
        window.open(`${ApiService.config.url}business/auth/social/${type}?redirect_app=test`, "Login", 'height=600,width=550')
    }
}